export default __webpack_public_path__ + "static/media/Foto13.c1565e65.png";